module.exports = __webpack_public_path__ + "img/Primordial-Process-2.04964ce8.png";